<template>
  <v-card :class="this.estado.claseFondo">
    <v-layout row wrap style="min-height:150px;">
      <v-flex xs12 md3 lg2>
        <v-img
          height="100%"
          style="height:150px;"
          :style="$vuetify.breakpoint.smAndDown ? 'max-height:150px;' : 'min-height:100%'"
          :src="require('@/assets/images/reserva/' + card.image)"
        />
      </v-flex>
      <v-flex xs12 md9 lg10 py-2 px-3>
        <v-layout column fill-height>
          <h1 class="primary--text text-uppercase textoAjustado">{{card.title}}</h1>
          <v-spacer></v-spacer>
          <v-layout mt-3 row justify-space-between align-center wrap style="flex-grow:0;">
            <v-flex xs12 sm8 lg8>
              <v-btn v-if="visible && this.id !== 'contrato'"
                flat
                large
                class="titleColor--text px-0"
                @click="ver()"
              >
                <v-icon medium left>remove_red_eye</v-icon>
                <span class="accion-text">{{$t('reservas.reservaCard.ver')}}</span>
              </v-btn>
              <v-btn v-if="visible && this.id === 'contrato'"
                flat
                large
                class="titleColor--text px-0"
                @click.stop
                :href="$contrato(reserva.contrato.documentoFirmado.documento.id)"
                target="_blank"
              >
                <v-icon medium left>remove_red_eye</v-icon>
                <span class="accion-text">{{$t('general.misc.ver')}}</span>
              </v-btn>
              <span
                v-if="!comprobarEstadoConBorrado(id, reserva) || texto"
                style="font-size:1.2rem"
                :class="estado.claseTextoPequeno"
                class="mr-4"
              >
                {{comprobarEstadoConBorrado(id, reserva) || !esPbcDenegado(id, reserva) ? texto : $t('reservas.reservaCard.reservaNoActiva')}}
                <v-menu
                  v-if="mostrarBotonTextoValidacionPbc"
                  :close-on-content-click="false"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      flat
                      class="ma-0 pr-2 pl-2"
                      :class="['red lighten-3', estado.claseTextoPequeno]"
                      style="min-width: min-content; height: 20px; top: -2px"
                    >
                      ...
                    </v-btn>
                  </template>
                  <v-card style="max-width: 700px">
                    <v-container fluid class="pa-2">
                      <v-layout column justify-center>
                        <o-base-text :class="estado.claseTextoPequeno" :marginBottom="false">
                          {{textoValidacionPbc}}
                        </o-base-text>
                      </v-layout>
                    </v-container>
                  </v-card>
                </v-menu>
              </span>
            </v-flex>
            <v-flex 
              v-if="comprobarEstadoConBorrado(id, reserva)" 
              :xs12="$vuetify.breakpoint.xsOnly"
            >
              <v-layout row justify-end align-center>
                <v-btn v-if="editable"
                  flat
                  large
                  class="mx-0 px-0"
                  @click="editar()"
                >
                  <span class="accion-text" :class="estado.claseTexto">{{textoAccion}}</span>
                  <v-icon medium right :class="estado.claseTexto">chevron_right</v-icon>
                </v-btn>
                <v-btn v-else
                  flat
                  large
                  class="mx-0 px-0"
                  @click="mostrarAlertaEditable()"
                >
                  <span class="accion-text" :class="estado.claseTexto">{{textoAccion}}</span>
                </v-btn>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex'
import reserva from '@/mixins/reserva'
import tarjetasReserva from '@/mixins/tarjetasReserva'
import OBaseText from '../generic/textos/OBaseText.vue'

export default {
  components: { OBaseText },
  mixins: [reserva, tarjetasReserva],
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      waitingForLoad: false
    }
  },
  computed: {
    card () {
      return this.tarjetasReserva.find(c => c.id === this.id)
    }
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add'
    }),
    mostrarAlertaEditable () {
      this.addAlert({texto: this.textoPopUpAlerta, color: 'error'})
    }
  }
}
</script>

<style lang="stylus" scoped>
  .accion-text
    font-size 1.7rem
    @media only screen and (max-width: 600px)
      font-size 1.5rem
  h1
    @media only screen and (max-width: 600px)
      font-size 1.6em
</style>




// WEBPACK FOOTER //
// src/components/reservas/ReservaCard.vue